import axios from 'axios'
import { baseUrl } from './config'

export function getBanners (reversed = false) {
  return axios.get(`${baseUrl}/banners`, {
    params: {
      limit: 50,
      offset: 0,
      sort: reversed ? 'sort_order:desc' : 'sort_order:asc'
    }
  })
}

export function createBanner (file) {
  const formData = new FormData()
  formData.append('image', file)
  return axios
    .post(`${baseUrl}/banners`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}

export function swapBanners (firstBannerID, secondBannerID) {
  return axios.put(`${baseUrl}/banners`, {
    first_banner: firstBannerID,
    second_banner: secondBannerID
  })
}

export function deleteBanner (bannerID) {
  return axios.delete(`${baseUrl}/banners/${bannerID}`)
}

export function getCaptchaLevel () {
  return axios.get(`${baseUrl}/captcha/status`)
}

export function setCaptchaLevel (level) {
  return axios.put(`${baseUrl}/captcha/status`, {
    level
  })
}


export function getRegLimits () {
  return axios.get(`${baseUrl}/rate-limits`, {
    params: {
      limit: 1,
      offset: 0,
      register: 1,
      sort: 'created_at:desc'
    }
  })
}

export function setRegLimits (id, params) {
  return axios.put(`${baseUrl}/rate-limits/${id}`, params)
}

export function getLoginLimits () {
  return axios.get(`${baseUrl}/rate-limits`, {
    params: {
      limit: 1,
      offset: 0,
      login: 1,
      sort: 'created_at:desc'
    }
  })
}

export function getHoneypot () {
  return axios.get(`${baseUrl}/pot/status`)
}

export function getFingerprint () {
  return axios.get(`${baseUrl}/fingerprint/status`)
}

export function getVerification () {
  return axios.get(`${baseUrl}/verification-settings/status`)
}

export function getEmailable () {
  return axios.get(`${baseUrl}/emailable/status`)
}

export function setHoneypot (status) {
  return axios.put(`${baseUrl}/pot/status`, status)
}

export function setFingerprint (state) {
  return axios.put(`${baseUrl}/fingerprint/status`, state)
}

export function setEmailable (state) {
  return axios.put(`${baseUrl}/emailable/status`, state)
}

export function setVerification (status) {
  return axios.put(`${baseUrl}/verification-settings/status`, status)
}

export function resetFingerprint (fingerprint) {
  return axios.post(`${baseUrl}/fingerprint/clear`, { fingerprint })
}

export function getEmailDomain (params) {
  return axios.get(`${baseUrl}/email-rules`, {
    params
  })
}

export function deleteEmailDomain (id) {
  return axios.delete(`${baseUrl}/email-rules/${id}`)
}

export function setEmailDomain (params) {
  return axios.post(`${baseUrl}/email-rules`, params)
}

export function editEmailDomain (id, params) {
  return axios.put(`${baseUrl}/email-rules/${id}`, params)
}

export function getLoginCaptchaStatus () {
  return axios.get(`${baseUrl}/guards/status`)
}

export function setLoginCaptchaStatus (status) {
  return axios.put(`${baseUrl}/guards/status`, status)
}
